import axios from 'axios';
import { urlPaymentModule } from '../utils';

export const apiPaymentModule = axios.create({
    baseURL: `${urlPaymentModule}`
});